"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Price = exports.parsePrice = exports.PRICE_DISPLAY = exports.PRICE_SEGMENT = exports.PRICE_FONT_TYPE = exports.PRICE_OPACITY = exports.PRICE_DECORATION = exports.PRICE_COLORS = exports.PRICE_SIZE = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
const next12_utils_enums_segment_1 = require("@gcloud-npm/next12.utils.enums.segment");
Object.defineProperty(exports, "PRICE_SEGMENT", { enumerable: true, get: function () { return next12_utils_enums_segment_1.SEGMENT; } });
const next12_utils_enums_colors_1 = __importStar(require("@gcloud-npm/next12.utils.enums.colors"));
Object.defineProperty(exports, "PRICE_COLORS", { enumerable: true, get: function () { return next12_utils_enums_colors_1.COLOR_DICTIONARY; } });
Object.defineProperty(exports, "PRICE_OPACITY", { enumerable: true, get: function () { return next12_utils_enums_colors_1.OPACITY; } });
const enums_1 = require("./enums");
Object.defineProperty(exports, "PRICE_SIZE", { enumerable: true, get: function () { return enums_1.PRICE_SIZE; } });
Object.defineProperty(exports, "PRICE_DECORATION", { enumerable: true, get: function () { return enums_1.PRICE_DECORATION; } });
Object.defineProperty(exports, "PRICE_FONT_TYPE", { enumerable: true, get: function () { return enums_1.PRICE_FONT_TYPE; } });
Object.defineProperty(exports, "PRICE_DISPLAY", { enumerable: true, get: function () { return enums_1.PRICE_DISPLAY; } });
const parsePrice = (number, decimals, decimalChar = ",", thousandChar = ".") => {
    let res = number;
    res = parseFloat(res).toFixed(decimals);
    res = res.replace(".", decimalChar);
    const splitNum = res.split(decimalChar);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
    if (splitNum[1] !== "00") {
        res = splitNum.join(decimalChar);
    }
    else {
        res = splitNum[0];
    }
    return res;
};
exports.parsePrice = parsePrice;
/**
 * obtiene la clase css general
 */
const getClassPrice = ({ size, decoration, fontType, display, segment, color, }) => {
    let classPrice = "price ";
    if (size) {
        classPrice = `${classPrice} price--size-${segment}--${size}`;
    }
    if (decoration) {
        classPrice = `${classPrice} price--decoration-${segment}--${decoration}`;
    }
    if (fontType) {
        classPrice = `${classPrice} price--fontType-${segment}--${fontType}`;
    }
    if (display) {
        classPrice = `${classPrice} price--display-${segment}--${display}`;
    }
    if (color) {
        classPrice = `${classPrice} price--color-${segment}--${color.toLowerCase()}`;
    }
    return classPrice;
};
/**
 * obtiene la clase css para la unidad
 */
const getClassPriceUnity = ({ size, unitySize, segment }) => {
    let classPrice = "";
    if (unitySize !== "") {
        classPrice = `price--unitySize-${segment}--${unitySize}`;
    }
    else if (size) {
        classPrice = `${classPrice} price--size-${segment}--${size}`;
    }
    return classPrice;
};
/**
 * parsea y normaliza el precio
 */
const checkAndNormalizePrice = ({ amount, decimals }) => {
    const priceToShow = amount;
    if (priceToShow === "" ||
        priceToShow === "undefined" ||
        priceToShow === null ||
        priceToShow === "null") {
        return null;
    }
    if (!(typeof priceToShow === "number" || typeof priceToShow === "string")) {
        return null;
    }
    return (0, exports.parsePrice)(priceToShow, decimals);
};
const StyledPrice = styled_components_1.default.span `
  ${(props) => (props.textColor ? `color:${props.textColor};` : "")}
`;
const Price = ({ segment, amount, color, className, unity, size, unitySize, decoration, opacity, fontType, decimals, cySelector, display, custoObjectInfo, }) => {
    const price = checkAndNormalizePrice({ amount, decimals });
    if (!price && !custoObjectInfo) {
        return null;
    }
    const colorOpacity = (0, next12_utils_enums_colors_1.default)(color, opacity, segment);
    let priceClass = getClassPrice({
        size,
        decoration,
        fontType,
        display,
        segment,
        color,
    });
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        priceClass = `${priceClass} custo-editable`;
    }
    const priceUnityClass = getClassPriceUnity({
        size,
        unitySize,
        segment,
    });
    return (react_1.default.createElement(StyledPrice, { "cy-data": cySelector, textColor: colorOpacity, className: `${className} ${priceClass}`, onClick: editModal },
        price,
        " ",
        react_1.default.createElement("span", { className: priceUnityClass }, unity)));
};
exports.Price = Price;
exports.Price.propTypes = {
    // segmento si es particulares o empresas
    segment: prop_types_1.default.oneOf(Object.values(next12_utils_enums_segment_1.SEGMENT)),
    amount: prop_types_1.default.number.isRequired,
    color: prop_types_1.default.oneOf(Object.values(next12_utils_enums_colors_1.COLOR_DICTIONARY)),
    unity: prop_types_1.default.string,
    className: prop_types_1.default.string,
    size: prop_types_1.default.oneOf(Object.values(enums_1.PRICE_SIZE)),
    unitySize: prop_types_1.default.oneOf(Object.values(enums_1.PRICE_SIZE)),
    decoration: prop_types_1.default.oneOf(Object.values(enums_1.PRICE_DECORATION)),
    opacity: prop_types_1.default.oneOf(Object.values(next12_utils_enums_colors_1.OPACITY)),
    fontType: prop_types_1.default.oneOf(Object.values(enums_1.PRICE_FONT_TYPE)),
    decimals: prop_types_1.default.number,
    cySelector: prop_types_1.default.string,
    display: prop_types_1.default.oneOf(Object.values(enums_1.PRICE_DISPLAY)),
    withSpace: prop_types_1.default.bool,
};
exports.Price.defaultProps = {
    segment: next12_utils_enums_segment_1.SEGMENT.GP,
    // color del precio
    color: next12_utils_enums_colors_1.COLOR_DICTIONARY.BLACK,
    unity: "€/mes",
    className: "",
    size: enums_1.PRICE_SIZE.REGULAR,
    unitySize: "",
    decoration: enums_1.PRICE_DECORATION.NONE,
    opacity: next12_utils_enums_colors_1.OPACITY.OP_1,
    fontType: enums_1.PRICE_FONT_TYPE.REGULAR,
    decimals: 2,
    cySelector: "",
    display: enums_1.PRICE_DISPLAY.INLINE,
    withSpace: false,
};
exports.default = exports.Price;
//# sourceMappingURL=index.js.map